import { LoadingPayload, ReassignUserReducerState } from "../types";

export const loadings = ({ state, payload, }: { state: ReassignUserReducerState, payload: LoadingPayload }): ReassignUserReducerState => {
    return { ...state, loadings: { ...state.loadings, [payload.name]: payload.value } }
}